export function CardBgPaleGreen200({
  width = 280,
  height = 164,
}: {
  width?: string | number;
  height?: string | number;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 280 164"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_76_5127)">
        <rect width="280" height="164" rx="20" fill="#B5DDD6" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M54.2257 185.979L128.357 146.984C139.003 141.384 142.452 128.773 136.342 119.132L124.305 100.137C122.131 96.7122 116.974 96.5265 114.529 99.8868C111.6 103.924 107.572 107.697 103.804 109.678C95.5722 114.009 84.7629 111.395 80.0326 103.93C75.3023 96.4653 78.2225 86.6294 86.4548 82.299C90.2359 80.31 95.8215 79.0253 101.124 78.7324C105.543 78.483 107.596 74.5012 105.772 70.8892L93.6984 51.8361C87.6233 42.249 74.1683 38.9642 63.6459 44.4993L42.5294 55.6072C38.7483 57.5962 34.1757 55.43 33.9196 51.4148C33.6192 46.5963 32.2288 41.5245 30.0562 38.0958C25.3272 30.6331 14.5226 28.0187 6.29127 32.344C-1.93569 36.6763 -4.85296 46.5088 -0.123989 53.9715C2.04866 57.4001 6.17427 61.0331 10.6042 63.6794C14.2927 65.8891 14.0653 70.5802 10.2843 72.5691L-10.8323 83.6771C-21.3547 89.2122 -24.96 101.471 -18.8848 111.058L-6.81119 130.112C-4.28983 133.357 0.521507 133.727 2.96772 130.366C5.89739 126.328 9.91141 122.563 13.6925 120.574C21.9247 116.244 32.734 118.857 37.4643 126.322C42.1946 133.787 39.2744 143.623 31.0421 147.953C27.2748 149.935 21.6754 151.227 16.3728 151.52C11.9575 151.769 9.55566 155.929 11.7203 159.356L23.7589 178.354C29.8684 187.995 43.5798 191.579 54.2257 185.979Z"
          fill="#CEFFF8"
        />
        <path
          d="M164.69 65.0929C166.493 65.623 168.464 64.6166 169.091 62.845C170.974 57.5302 168.114 51.9325 162.705 50.3421L162.13 50.173C156.721 48.5826 150.81 51.6018 148.927 56.9166C148.3 58.6882 149.253 60.5541 151.056 61.0842L164.69 65.0929Z"
          fill="#B5F6EC"
        />
        <path
          d="M122.58 0.614301C124.637 -2.63174 123.548 -6.7135 120.147 -8.50255L118.506 -9.36529C109.209 -14.256 97.1138 -11.0272 91.4908 -2.15354C85.8677 6.72008 88.8464 17.8783 98.1437 22.7689L99.7838 23.6317C103.185 25.4207 107.609 24.2396 109.666 20.9936L122.58 0.614301Z"
          fill="#B5F6EC"
        />
      </g>
      <defs>
        <clipPath id="clip0_76_5127">
          <rect width="280" height="164" rx="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
